<template>
  <router-view />
</template>

<script>
import { useQuasar } from 'quasar'
import update from './mixins/updateMixin'

export default {
  name: 'App',
  mixins: [update],
  setup() {
    const q = useQuasar()
    return { q }
  },
  created () {
    // handle global quasar flash message view (event)
    this.$event.on('flash', (params) => {
      this.q.notify(params)
    })
  },
}
</script>
